import Vue from "vue";
import Vuex from "vuex";

// Modules
import ecommerceStoreModule from "@/views/apps/e-commerce/eCommerceStoreModule";
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import message from "./message";
import timesheet from "./timesheet";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    message,
    appConfig,
    verticalMenu,
    "app-ecommerce": ecommerceStoreModule,
    timesheet: {
      namespaced: true,
      getters: timesheet.getters,
      actions: timesheet.actions,
      mutations: timesheet.mutations,
      state: timesheet.state,
    },
  },
  strict: process.env.DEV,
});
